import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./msalConfig";

/**
 * One instance for the whole application. `@azure/msal-browser` requires an explicit
 * initialize() before any other call, and handleRedirectPromise() has to run once on load or a
 * return from the sign-in redirect is silently dropped. Both are awaited here so every caller
 * sees a ready client.
 */
export const msalClient = new PublicClientApplication(msalConfig);

let ready: Promise<void> | null = null;

export function ensureMsalReady(): Promise<void> {
  ready ??= (async () => {
    try {
      await msalClient.initialize();
      await msalClient.handleRedirectPromise();
    } catch (error) {
      // A rejected init must not stick around forever - a bad redirect response or a corrupted
      // sessionStorage entry would otherwise poison every later login()/logout()/getAccessToken()
      // for the rest of the page's life, with no way back short of a full reload. Clearing the
      // cache lets the next call retry instead.
      ready = null;
      throw error;
    }
  })();

  return ready;
}
